import { useEffect, useState } from "react";

import { getFtpConnections } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

/**
 * @name    useFtpConnections
 *
 * @summary get an array of FTP connections
 *
 * @returns (array) the FTP connection records
 */

export function useFtpConnections() {
  const [records, setRecords] = useState(null);

  useEffect(() => {
    async function retrieveRecords() {
      const { success, data, message } = await getFtpConnections();
      if (success) {
        setRecords(data.records);
      } else {
        handleProgramError(
          new Error(
            `useRelated | unsuccessful call to getAll, message: ${message}`
          )
        );
      }
    }
    retrieveRecords();
  }, []);

  return records;
}
